import React from "react";
import Header from "../../Header1";
import Footer from "../../Footer2";
import PageContent from "./content";

const HomeOne = () => {
	return (
		<>
			<div className="page-wrapper">
				<Header />
				<PageContent />
				<Footer />
			</div>
		</>
	);
};
export default HomeOne;
